import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const COPY_OFFER_MUTATION = gql`
  mutation copyQuote($documentVersion: DocumentVersionInput!) {
  quotes {
    copy(documentVersion: $documentVersion) {
      documentId
      latestRevision
      revisions {
        title
        documentId
        revision
        locked
      }
    }
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class CopyOfferMutation extends Mutation<RootMutation> {
  document = COPY_OFFER_MUTATION;
}
